import { css as e, styled as t } from "styled-components";
//#region src/components/Table/TableStyles.tsx
var n = t.div`
    width: 100%;
    contain: inline-size;
    position: relative;
    border: 1px solid ${({ theme: e }) => e.colors.border};
    border-radius: ${({ theme: e }) => e.radii.lg};
    background-color: ${({ theme: e }) => e.colors.card};
    overflow: hidden;

    display: flex;
    flex-direction: column;
    /* Bounded (internal-scroll) tables cap out at $maxHeight and let ScrollWrapper
       scroll; unbounded (page-scroll) tables size to content and scroll the window. */
    height: ${({ $maxHeight: e }) => e ? "auto" : "100%"};
    max-height: ${({ $maxHeight: e }) => e ?? "100%"};
`, r = t.div`
    width: 100%;
    flex: 1;
    min-height: 0;
    overflow: auto;

    ${({ $isScrolled: t }) => t && e`
            &.is-scrolled {
            }
        `}
`, i = t.table`
    width: 100%;
    border-collapse: separate; /* Required for sticky borders to not overlap weirdly */
    border-spacing: 0;
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    color: ${({ theme: e }) => e.colors.cardForeground};
    table-layout: auto;
    min-width: max-content;
`, a = t.thead`
    position: sticky;
    top: 0;
    z-index: 20;
`, o = t.tbody``, s = t.tr`
    transition: background-color ${({ theme: e }) => e.transitions.fast};
    background-color: ${({ theme: e, $isSelected: t }) => t ? e.colors.primary + "11" : e.colors.card};

    ${({ $clickable: t, theme: n, $isSelected: r }) => t && e`
            cursor: pointer;
            &:hover {
                background-color: ${r ? n.colors.primary + "22" : n.colors.muted};
            }
        `}
`, c = (t, n, r, i) => t ? e`
        position: sticky;
        ${t}: ${n || "0px"};
        top: ${r ? "0" : "auto"};
        /* Pinned headers highest, pinned columns next */
        z-index: ${r ? 30 : 10};

        /* Opaque, or the rows scrolling under a pinned cell bleed through. */
        background-color: ${i.colors.card};
        background-clip: padding-box; /* Or the borders bleed too. */

        &::after {
            content: '';
            position: absolute;
            top: 0;
            bottom: -1px; /* Cover bottom border gap */
            width: 15px; /* Decreased width */
            pointer-events: none;
            transition: opacity ${i.transitions.fast};
            ${t === "left" ? "right: -15px; background: linear-gradient(to right, rgba(0,0,0,0.03), transparent);" : "left: -15px; background: linear-gradient(to left, rgba(0,0,0,0.03), transparent);"}
        }
    ` : e`
            position: ${r ? "sticky" : "relative"};
            top: ${r ? "0" : "auto"};
            z-index: ${r ? 20 : 0};
        `, l = t.th`
    padding: ${({ theme: e }) => e.spacing(2, 3)};
    text-align: ${({ $align: e }) => e};
    width: ${({ $width: e }) => typeof e == "number" ? `${e}px` : e ?? "auto"};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.xs};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.semibold};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    text-transform: uppercase;
    letter-spacing: 0.05em;
    white-space: nowrap;
    border-bottom: 1px solid ${({ theme: e }) => e.colors.border};

    background-color: ${({ theme: e }) => e.colors.card};
    background-clip: padding-box;

    ${({ $pinned: e, $offset: t, theme: n }) => c(e, t, !0, n)}

    &[data-is-selection="true"] {
        background-color: ${({ theme: e }) => e.colors.card};
    }
`, u = t.td`
    padding: ${({ theme: e }) => e.spacing(2, 3)};
    text-align: ${({ $align: e }) => e};
    color: ${({ theme: e }) => e.colors.foreground};
    vertical-align: middle;
    border-bottom: 1px solid ${({ theme: e }) => e.colors.border};

    /* Mirrors the TR, so a sticky cell never bleeds through. */
    background-color: inherit;
    background-clip: padding-box;

    ${({ $pinned: e, $offset: t, theme: n }) => c(e, t, !1, n)}
`, d = t.td`
    padding: ${({ theme: e }) => e.spacing(8)};
    text-align: center;
    color: ${({ theme: e }) => e.colors.mutedForeground};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
`;
//#endregion
export { d as EmptyCell, n as OuterWrapper, r as ScrollWrapper, i as StyledTable, o as TBody, u as TD, l as TH, a as THead, s as TR, c as getPinStyles };
